import React from "react";

const TopHeadingError = () => (
  <div className="reserve-warning-wrapper m-t-1 p-1">
    <div className="reserve-warning">
      <div className="icon">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="16" fill="#d04111ff"/>
          <path d="M16 9v8" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="16" cy="22" r="1.5" fill="#fff"/>
        </svg>
      </div>
      <div className="text">
        <div className="title">NCDLT PoR DON-3 Warning Alert!</div>
        <div className="desc">
          The DTC server for the PoR has failed to connect and the asset reserves backing ICUSD circulation have fallen below the required threshold.<br/>
          <span className="highlight">Ensure that DTC server is restored ASAP or replenish the classified digital asset reserves immediately to prevent disruption.<br/>If reserves are not restored, ICUSD circulation will be paused within 24 hours.</span><br/>
          For the list of eligible reserve assets, visit: <a href="https://ramzmarketcap.com" target="_blank" rel="noopener noreferrer">ramzmarketcap.com</a>
        </div>
      </div>
    </div>
  </div>
);

export default TopHeadingError;
